module.exports = __webpack_public_path__ + "media/src/assets/home_background-4baa9f8df2c5de2092446daf45bc4d3c.jpeg";